import constants from '@/app-configs/constants'

export default [
  {
    path: '/queued-letters',
    name: 'queued-letters',
    component: () => import('@/views/queuedletters/QueuedLetters.vue'),
    meta: {
      pageTitle: 'DEBTIA_QUEUED_LETTERS',
      breadcrumb: [
        {
          text: 'DEBTIA_QUEUED_LETTERS',
          active: true,
        },
      ],
      action: constants.action.permissionLogin,
      resource: constants.resource.user,
    },
  },
]
